


































import { Either } from 'fp-ts/lib/Either'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { AutoLoadComplete, AutoLoadError } from '@/components/organisms/auto-load/model'
import ItemListAutoLoadable from '@/components/organisms/item-list/AutoLoadable.vue'
import ApiBrand from '@/models/api/brand'
import { ListWithPagination } from '@/models/api/response/list'
import { ItemKind } from '@/models/item/kind'
import ItemService from '@/services/api/productclass'
import AppId from '@/util/appid'

import { log } from '@/log'
import BehaviorConfig from '@/models/app-config/behavior/behavior'

@Component({
  components: {
    ItemListAutoLoadable,
  },
})
export default class FavoriteItems extends Vue {

  @Prop({ default: null })
  brand: ApiBrand | null

  message: string = ''

  get brandEnglishName(): string {
    return this.brand ? this.brand.englishName : ''
  }

  get appId(): string {
    return AppId.getByBrandName(this.brandEnglishName)
  }

  get query() {
    return {
      like: true,
      with: 'belonging_to,part,stock~detail,like,indexsummary',
      /*
       * FIXME: 本来サブスクリプション申し込み用商品が表示できないようにするべきだが、 like=true とEngineがエラーを起こす
       *
       * ただし、サブスクリプション申し込み用商品は一覧にも表示せず詳細も表示させないので、
       * 結果的に問題とはならないかもしれない.
       * @see https://github.com/my-color/front/issues/5656#issuecomment-914223746
       * @see client/ajax/src/vue/components/templates/Favorite.vue 同様の問題を抱えている
       */
      tags: 'mycolor.product.fku',
      ...this.brand && { brand: this.brand.id },
    }
  }

  get itemKind(): ItemKind {
    const behavior = BehaviorConfig.createFromBrand(this.brand)

    return behavior.itemList.layout as ItemKind
  }

  itemService = new ItemService()

  fetchItemList(baseQuery: object): Promise<Either<Error, ListWithPagination<any>>> {
    return this.itemService.listFkuForUserWithPagination({
      ...baseQuery,
      ...this.query,
    })
  }

  onError(error: AutoLoadError) {
    log.error(error)

    this.message = 'データを取得できませんでした'
  }

  onComplete(result: AutoLoadComplete) {
    if (!result.pagination || result.pagination.total === 0) {
      this.message = 'お気に入りに登録している商品はありません'

      return
    }
  }

  get shouldAutoload(): boolean {
    return !this.message
  }
}
